import React, {useState} from "react";
import {Route} from "@/routing/Router";
import EmployeeHeading from "@widgets/employees/editor/heading/EmployeeHeading";
import DeleteEmployeeModal from "@widgets/employees/editor/delete/DeleteEmployeeModal";
import EmployeeSectionTabs from "@widgets/employees/editor/tabs/EmployeeSectionTabs";
import {SetEmployeeProps} from "@pages/authenticated/admin/employees/Employee";

type Props = SetEmployeeProps & {
    route: Route,
    initialLoading: boolean,
};

const EmployeeEditor = ({route, initialLoading, employee, setEmployee}: Props) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    return (
        <>
            <EmployeeHeading
                route={route}
                initialLoading={initialLoading}
                employee={employee}
                setShowDeleteModal={setShowDeleteModal}
            />

            <EmployeeSectionTabs
                initialLoading={initialLoading}
                employee={employee}
                setEmployee={setEmployee}
            />

            {
                employee !== null &&
                <DeleteEmployeeModal
                    employee={employee}
                    showDeleteModal={showDeleteModal}
                    setShowDeleteModal={setShowDeleteModal}
                />
            }
        </>
    );
};

export default EmployeeEditor;